import { render, staticRenderFns } from "./CardRequestAddressChange.vue?vue&type=template&id=0260b913"
import script from "./CardRequestAddressChange.vue?vue&type=script&lang=js"
export * from "./CardRequestAddressChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports